// --------------------------------------------------------------
// Created On: 2024-11-19
// Author: Zachary Thomas
//
// Last Modified: 2024-11-19
// Modified By: Zachary Thomas
//
// Copyright 2024 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React, { useState, useEffect } from "react";
import { CAROUSEL_IMAGES, CAROUSEL_DISPLAY_TIME_MILLISECONDS } from "../../../constants/miscellaneous";
import styles from "./DashboardCarousel.module.scss";

// This is a carousel banner that shows some pump related images.
export default function DashboardCarousel(): Component {
  const [animationCounter, setAnimationCounter] = useState<number>(0);
  const animationCounterMaxValue = CAROUSEL_IMAGES.length * CAROUSEL_DISPLAY_TIME_MILLISECONDS;

  // Handle incrementing the animation counter to cycle between images.
  useEffect(() => {
    const newTimerId = setTimeout(() => {
      if (animationCounter + CAROUSEL_DISPLAY_TIME_MILLISECONDS >= animationCounterMaxValue) {
        setAnimationCounter(0);
      } else {
        setAnimationCounter(animationCounter + CAROUSEL_DISPLAY_TIME_MILLISECONDS);
      }
    }, CAROUSEL_DISPLAY_TIME_MILLISECONDS);
    return () => {
      clearTimeout(newTimerId);
    };
  }, [animationCounter]);

  // Figure out if a specific image should be shown based on its index and the current counter.
  function carouselImageIsHidden(animationCounter: number, index: number): boolean {
    return (
      index !== 0 &&
      (animationCounter < index * CAROUSEL_DISPLAY_TIME_MILLISECONDS ||
        animationCounter >= (index + 1) * CAROUSEL_DISPLAY_TIME_MILLISECONDS)
    );
  }

  return (
    <div data-item="dashboard-carousel" className={styles.body}>
      {CAROUSEL_IMAGES.map((carouselImage, i) => (
        <img
          key={i}
          className={`${styles.carouselImage} ${carouselImageIsHidden(animationCounter, i) ? styles.hidden : ""}`}
          src={carouselImage}
          alt="eCommerce Carousel"
        />
      ))}
    </div>
  );
}
